var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.dataItems.length)?_c('div',[_c('b-table',{staticClass:"fraudReportHeaderTable",attrs:{"responsive":"","striped":"","bordered":"","fields":_vm.dataFields,"items":_vm.dataItems}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }